export default __webpack_public_path__ + "static/media/Anti-histaminebk.e622edcd.jpg";